// import Input from "../../components/input/input";
// import { useForm, SubmitHandler } from "react-hook-form"
import './styles.scss';

// import { Button } from "@mui/material";
import { useAuth0 } from '@auth0/auth0-react';

// import ImersiveLogoDark from "../../assets/vertical-immersive-logo-dark.svg";
// import { useNavigate } from "react-router";

// type Inputs = {
//   email: string
//   password: string
// }

export default function Login() {
  // const navigate = useNavigate();
  useAuth0().loginWithRedirect();

  return <></>;
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<Inputs>()

  // const onSubmit: SubmitHandler<Inputs> = (data) => {
  //   console.log(data);
  // }

  // return <div className="login-container">
  //   <img src={ImersiveLogoDark} alt="Immersive finance" className="logo" />
  //   <div className="content">
  //     <div className="header">
  //       <h2>Log in</h2>
  //       <span>First login? <span className="setup-password">Setup your password</span></span>
  //     </div>
  //     <div className="login-body">
  //       <form className="form" onSubmit={handleSubmit(onSubmit)}>
  //         <Input
  //           label="Email"
  //           placeholder="your-email@mail.com"
  //           type="text"
  //           {...register("email", { required: true })}
  //           errors={errors?.email?.type}
  //         />
  //         <Input
  //           label="Password"
  //           placeholder="Password"
  //           type="password"
  //           {...register("password", { required: true })}
  //           errors={errors?.password?.type}
  //         />
  //         <Button variant="text" className="password-forgot" onClick={() => navigate("/reset-password") }>Forgot my password</Button>
  //         <Button disabled variant="contained" onClick={() => loginWithRedirect()}>
  //           Login
  //         </Button>
  //       </form>
  //     </div>
  //   </div>
  // </div>
}
